<template>
	<div class="panel_shouyin">
		<div>
			<el-table :data="list" style="width: 100%">
				<el-table-column label="顾客" width="90">
					<template slot-scope="scope">
						{{scope.row.user_info.nick_name}}
					</template>
				</el-table-column>
				<el-table-column label="手机号" width="110">
					<template slot-scope="scope">
						{{scope.row.user_info.user_mobile}}
					</template>
				</el-table-column>
				<el-table-column label="状态" width="100">
					<template slot-scope="scope">
						{{scope.row.states==0?'已删除':''}}
						{{scope.row.states==1?'已预约':''}}
						{{scope.row.states==2?'预约审核通过':''}}
						{{scope.row.states==3?'预约完成':''}}
						{{scope.row.states==-2?'取消预约':''}}
						{{scope.row.states==-3?'预约审核失败':''}}
						{{scope.row.states==-4?'预约成功未到':''}}
					</template>
				</el-table-column>
				<el-table-column label="宠物" width="90">
					<template slot-scope="scope">
						{{scope.row.pet_info.nick_name}}
					</template>
				</el-table-column>
				<el-table-column label="预约服务" width="70">
					<template slot-scope="scope">
						{{scope.row.service_info.name}}
					</template>
				</el-table-column>
				<el-table-column label="医生/美容师" >
					<template slot-scope="scope">
						{{scope.row.service_info.operation_user_name}}
					</template>
				</el-table-column>
				<el-table-column label="预约备注" >
					<template slot-scope="scope">
						{{scope.row.remarks}}
					</template>
				</el-table-column>
				<el-table-column label="预约日期" width="80">
					<template slot-scope="scope">
						{{$public.FTime(scope.row.time_info.date,'YYYY-MM-DD')}}
					</template>
				</el-table-column>
				<el-table-column label="预约时间" width="100">
					<template slot-scope="scope">
						{{scope.row.time_info.start_time}} -
						{{scope.row.time_info.end_time}}
					</template>
				</el-table-column>
				<el-table-column label="操作" width="130">
					<template slot-scope="scope">
						<el-button @click="see(scope.row)" type="text" size="small">查看</el-button>
						<el-button v-if="scope.row.states!==-2" @click="edit(scope.row)" type="text" size="small">编辑</el-button>
						<el-button v-if="scope.row.states==1" @click="check(scope.row)" type="text" size="small">审核</el-button>
						<el-button v-if="scope.row.states==2" @click="arrive(scope.row)" type="text" size="small">到店</el-button>
						<!-- <el-button @click="del(scope.row)" type="warning" size="small">删除</el-button> -->
					</template>
				</el-table-column>
			</el-table>
			<page :page="page.page" :total="page.total" @change="changePage"></page>
		</div>
		<yuyueSee v-if="drawerActivitySee_state" :curRow="curItem" @submit="submit_drawerActivitySee"></yuyueSee>
		<div v-if="drawerActivityEdit_state">
			<yuyueEdit :yuyueId="curItem._id" @submit="submit_drawerActivityEdit"></yuyueEdit>
		</div>
		<div v-if="drawerActivityVerify_state">
			<yuyueVerify :yuyueId="curItem._id" @submit="submit_drawerActivityVerify"></yuyueVerify>
		</div>
		<div v-if="drawerActivityArrival_state">
			<yuyueArrival :yuyueId="curItem._id" @submit="submit_drawerActivityArrival"></yuyueArrival>
		</div>
	</div>
</template>
<script>
	import page from "../../../../components/page.vue"
	import yuyueSee from "../drawer/yuyueSee.vue"
	import yuyueEdit from "../drawer/yuyueEdit.vue"
	import yuyueVerify from "../drawer/yuyueVerify.vue"
	import yuyueArrival from "../drawer/yuyueArrival.vue"
	export default {
		components:{page,yuyueSee,yuyueEdit,yuyueVerify,yuyueArrival},
		data(){
			return{
				list:[],
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				// see
				drawerActivitySee_state:false,
				curItem:{},
				// edit
				drawerActivityEdit_state:false,
				// check
				drawerActivityVerify_state:false,
				// arrival
				drawerActivityArrival_state:false,
			}
		},
		computed:{
			curShopId(){
				return this.$store.state.shopId;
			},
		},
		mounted(){
			this.getList();
		},
		methods: {
			//////////////// see
			see(row){
				this.curItem=row;
				this.drawerActivitySee_state = true;
			},
			submit_drawerActivitySee(){
				this.drawerActivitySee_state = false;
			},
			////////////////  edit
			edit(row){
				this.curItem=row;
				this.drawerActivityEdit_state = true;
			},
			submit_drawerActivityEdit(obj){
				this.drawerActivityEdit_state = false;
				if(obj.type==="success"){
					this.page.page=1;
					this.getList();
				}
			},
			////////////////  check
			check(row){
				this.curItem=row;
				this.drawerActivityVerify_state = true;
			},
			submit_drawerActivityVerify(obj){
				this.drawerActivityVerify_state = false;
				if(obj.type==="success"){
					this.page.page=1;
					this.getList();
				}
			},
			////////////////  arrival
			arrive(row){
				this.curItem=row;
				this.drawerActivityArrival_state = true;
			},
			submit_drawerActivityArrival(obj){
				this.drawerActivityArrival_state = false;
				if(obj.type==="success"){
					this.page.page=1;
					this.getList();
				}
			},
			// 改变分页
			changePage(a){
				this.page.page=a;
				this.getList();
			},
			// 获取表格数据
			getList() {
				let params = {
					"state": 1,   // -1 全部 0 已删除 1 已预约 2 预约审核通过 3 预约完成 -2 取消预约 -3预约审核失败 -4 预约成功未到
					"pageIndex":this.page.page,
					"pageSize": this.page.pageSize
				}
				this.$http.post('/api/Reservation/List', params).then(res => {
					if (res.code == 0) {
						this.list = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
		}
	}
</script>
<style scoped lang="scss">
.panel_shouyin{
	height: 100%;background-color: #fff;padding:0 0 20px;box-sizing: border-box;
	// .titleLine{
	// 	width:100%;
	// 	background-color: #fff;
	// 	height: 44px;
	// 	line-height: 30px;
	// 	padding:8px 8px;
	// 	box-sizing: border-box;
	// 	margin-bottom: 4px;
	// }
}
</style>
